import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';
import { EquityFieldKey } from 'types';
import { HeatmapMetric } from 'components/optionsCalculator/pnlChart/heatmapMetrics';

const { persistAtom } = recoilPersist();

export const optionsCalculatorTickerCurrentFieldsState = atom<EquityFieldKey[]>(
  {
    key: 'optionsCalculator-tickerCurrentFieldsState',
    default: [
      EquityFieldKey.earningsDate,
      EquityFieldKey.prevClose,
      EquityFieldKey.wkHigh52,
      EquityFieldKey.wkLow52,
    ],
    effects_UNSTABLE: [persistAtom],
  },
);

export const optionsCalculatorShowKeyLevelsState = atom<boolean>({
  key: 'optionsCalculator-keyLevelsState',
  default: true,
  effects_UNSTABLE: [persistAtom],
});

// Standalone page only — canvas keeps this on its own per-widget config
// instead (see useOptionsCalculatorCanvasState) so instances don't share it.
export const optionsCalculatorEnabledHeatmapMetricsState = atom<
  HeatmapMetric[]
>({
  key: 'optionsCalculator-enabledHeatmapMetricsState',
  default: ['pnl'],
  effects_UNSTABLE: [persistAtom],
});
